import React from "react";
import { Dropdown } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const NotificationBell = () => {
  const navigate = useNavigate();

  const notificationMenu = {
    items: [
      {
        key: "1",
        label: "View All Notifications",
        onClick: () => navigate("/notifications"),
      },
    ],
  };

  return (
    <Dropdown menu={notificationMenu} placement="bottomRight">
      <BellOutlined className="notification-bell" />
    </Dropdown>
  );
};

export default NotificationBell;
